export const CODIGOS_ERROR_HTTP = {
  0: 'Sin conexión a internet',
  500: 'Error interno.  Contacte con soporte ténico',
  401: 'Error de autenticación. Cierre e inicie de nuevo sesión',
  404: 'La web está desactualizada. Limpia la cache y vuelve a intentarlo de nuevo.',
};
export const CODIGOS_ERROR_MITO = {
 9001: "Atla Cliente: Este código cliente, ya existe en el sistema. Prueba ha cambiarlo por otro",
 9002: "Atla Cliente: Este subdominio, ya existe en el sistema. Prueba ha cambiarlo por otro"
};
